//  const baseURL = "http://localhost:5047/api";
//  const baseURL="https://girvibackend.prakash-n-co.in/api";
const baseURL="https://girvi2backend.grjewellers.in/api";
// const baseURL="https://sashigirvibackend.riddhi-infotech.com/api";

export default baseURL;